import React, { FC } from 'react';

export const OrderedList: FC = (props) => <ol {...props} />;
